<template>
  <div>
    <!-- 新版订阅 -->
    <div :class="['mod-subscription', className]">
      <!-- 头图 -->
      <img
        class="bg"
        :src="currentItem.serviceZoneMaterial && currentItem.serviceZoneMaterial.headImg ? currentItem.serviceZoneMaterial.headImg : ''"
        alt=""
      />
      <!-- 衔接阴影 -->
      <span class="mask"></span>
      <!-- 返回按钮 -->
      <!-- 因为每个组件上这个按钮的行为差别很大，这里写成slot -->
      <slot name="top"></slot>

      <!-- 业务内容 -->
      <div class="detail">
        <div class="game-info">
          <img class="logo-game" :src="serviceZoneTopLogo" />
          <div class="game-left-box">
            <div ref="gameTitle" class="game-title cpuspeed">{{ serviceZoneTopName }} <span class="certification"></span></div>
            <!-- 第三方登录态时暂不展示授权入口和订阅入口，用户绑定后显示 -->
            <subscribe-item
              v-if="!checkThirdSession && !invalidSession"
              :has-subscribe="subscribeId && !hideSubscribe && !isWzryShopSource ? true : false"
              :has-auth-entry="!checkThirdSession"
              show-type="zoneTop"
              :subscribe-id="subscribeId"
              :group-id="currentItem.groupId"
              :biz-id="currentItem.busId"
              :change-subscribe-promp="changeSubscribePromp"
              pf-structure="zone_top"
            ></subscribe-item>
          </div>
        </div>
      </div>

      <!-- 用户信息 -->
      <slot name="user-info"></slot>
    </div>

    <!-- 确认取消订阅的弹窗 -->
    <SubscribePrompt ref="subscribePromptRef"></SubscribePrompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getParam } from "../../../utils/url"
import SubscribeItem from "../../common/Subscribe/SubscribeItem.vue"
import SubscribePrompt from "../../common/Subscribe/SubscribePrompt.vue"
import subscribeItem from "../../mixins/subscribeItem"
import { convertRemToPixels } from "../../../utils/helper"
import { WZRY_SHOP_SOURCE } from "../../../constants/langs"
import { checkSessionType } from "@api/user"

export default {
  name: "ServiceZoneTop",
  components: {
    SubscribeItem,
    SubscribePrompt
  },
  mixins: [subscribeItem],
  props: ["className", "invalidSession"],
  data() {
    return {
      // 是否展示取消订阅弹窗
      promptConfirmSubscribe: false
    }
  },
  computed: {
    ...mapGetters(["currentItem", "storeConfigWithGroupIdKey", "storeConfig", "pfSource", "pf", "sessionObj"]),
    subscribeId() {
      if (this.currentItem && this.currentItem.groupId && this.storeConfigWithGroupIdKey[this.currentItem.groupId]) {
        return this.storeConfigWithGroupIdKey[this.currentItem.groupId].subscribeId
      } else {
        return ""
      }
    },
    hideSubscribe() {
      return getParam("hide_subscribe")
    },
    // 王者荣耀店铺需要有不一样的icon
    serviceZoneTopLogo() {
      if (this.currentItem) {
        if (this.currentItem.groupId == 2) {
          return "http://midas.gtimg.cn//h5/store/images/wzry/logo.png"
        }
        return this.currentItem.icon
      }

      return ""
    },
    // 王者荣耀店铺分店的名称
    serviceZoneTopName() {
      if (this.currentItem) {
        if (this.currentItem.groupId == 2) {
          return "王者荣耀官方商城"
        }

        return `${this.currentItem.name}专区`
      }

      return ""
    },
    isWzryShopSource() {
      return this.pf.indexOf(WZRY_SHOP_SOURCE) > -1
    },
    checkThirdSession() {
      return checkSessionType({ sessionObj: this.sessionObj }) == "third"
    }
  },
  methods: {
    changeSubscribePromp({ promptStatus, subscribeId = "", groupId = "" }) {
      this.$refs.subscribePromptRef.changePromptConfirmSubscribe({ promptStatus, subscribeId, groupId })
    },
    closeSubscribe() {
      this.$refs.subscribePromptRef.confirmSubscribe()
    },
    resetTitleFontSize() {
      setTimeout(() => {
        let gameTitle = this.$refs.gameTitle
        let px = convertRemToPixels(2.05)

        resetFontSize(gameTitle, px, 12, 24)
      }, 1000)
    }
  }
}

// 根据宽度调整字体的大小以防止换行
function resetFontSize(divWord, maxWidth, minSize, maxSize) {
  if (!divWord) {
    return
  }

  divWord.style.fontSize = `${maxSize}px`

  let i = maxSize
  while (divWord.offsetWidth > maxWidth && i >= minSize) {
    divWord.style.fontSize = `${i--}px`
  }
}
</script>
